import React from "react";
import {NavLink} from "react-router-dom";
import ContentBox from "../../../../../../../components/content-box/ContentBox";
import PageActions from "../../../../../../base/PageActions";
import Breadcrumbs from "../../../../../../../components/breadcrumbs/Breadcrumbs";
import _image_service from "../../../../../../../services/ImageService";
import '../../../../../../styles/Common.scss';
import '../../../WorldPages.scss';
import '../MagicItemsPage.scss';

interface MagicAmuletPageProps {
}

const MagicAmuletPage = (props: MagicAmuletPageProps) => {

    const page: PageActions = new PageActions({
        title: `Casarok: Magic Runestones - Chase the Fox`,
        description: "Runestones are magical artifacts that have been infused with powerful spells found in the Snowscape of Casarok!",
        keywords: ["casarok", "magic", "magic compendium", "magic item", "magical", "magical item", "magic runestone", "runestone"],
        imgSrc: `chase/world/magic/items/runestone.png`,
        url: `world/magic/items/runestone`
    });

    return page.generateMetaContent(
        <>
            <ContentBox header="Runestones">
                <Breadcrumbs path={page.getUrl()}/>
                <div className="world-page-static">
                    <img className="magic-item-pic right"
                         src={_image_service.getCdnImageSrc(`chase/world/magic/items/runestone.png`)}
                         alt="A jagged rock with a glowing magical rune"
                         title="The Runestone of the Driftpaw Snowprint, one of the ancient runestones"/>
                    <p>
                        Runestones are a class of magical focus that contain a single powerful spell that can be cast
                        by a user. They also empower the caster's spells that match
                        the <NavLink className="world-link" to="/world/magic/elements">element</NavLink> of the
                        spell infused into the runestone. The primary spell infused into the runestone takes some time
                        to learn, so it is not uncommon for the wielder to use it solely for the purpose of empowering
                        their own magic. The spells that are empowered into the runestone, however, are not usually
                        capable of being cast by an ordinary mage. This property of runestones has the potential to give
                        ordinary mages the ability to cast spells for which they would not normally have the capacity.
                        The majority of runestones are found
                        in <NavLink className="world-link" to="/world/geography">the Snowscape</NavLink> of
                        northern Casarok where they were made.
                    </p>
                    <p>
                        The creation of runestones were only done during
                        the <NavLink className="world-link" to="/world/history">pre-Cataclysmic</NavLink> era of
                        Casarok. They require the use of special rocks that contain magic-infused minerals. Those stones
                        then need to be chiseled into a small enough shape that can be carried by an individual caster.
                        A runic symbol representing the spell to be infused into the runestone is then carved into the
                        front of the stone. A group of casters must then create a runic circle on the ground, place
                        the stone in the center, gather around the circle, and then call upon
                        a <NavLink className="world-link" to="/world/religion/pantheon">god or goddess</NavLink> to
                        empower the stone with the desired spell. Once empowered with the spell, the rune carved into
                        the runestone gives off a glow tied to the element of the infused spell.
                    </p>
                    <p>
                        Runestones were featured heavily in chapter 2
                        of <NavLink className="world-link" to="/comics/talechasers">Tale Chasers</NavLink>.
                    </p>
                    <ul className="spaced">
                        <li>
                            The central point of conflict in the story is the Runestone of the Driftpaw Snowprint. Its
                            main spell allows the caster to swap the bodies of individuals, literally allowing them to
                            walk in each other's paws.
                        </li>
                        <li>
                            The <NavLink className="world-link" to="/characters/valorienne">antagonist</NavLink> uses
                            the Runestone of the Forgotten Jotnr. The primary spell here allows the wielder to summon
                            and control
                            a <NavLink className="world-link" to="/world/bestiary/monster/frost-jotnr">frost jotnr</NavLink>.
                        </li>
                        <li>
                            <NavLink className="world-link" to="/characters/snow">Snow</NavLink> uses an as-of-yet
                            unnamed runestone. The primary spell contained within the runestone has also not been
                            revealed.
                        </li>
                    </ul>
                </div>
            </ContentBox>
        </>
    );
}

export default MagicAmuletPage;